module.exports = __webpack_public_path__ + "static/pad-img2-3043a317c20b5f671532ae9dc54276b4.png";